import { XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

const RemoveButton = ({ label, onClick }) => (
  <Button
    type="button"
    variant="ghost"
    size="icon"
    aria-label={label}
    onClick={onClick}
  >
    <XIcon />
  </Button>
);

export default RemoveButton;
